export default __webpack_public_path__ + "static/media/person-street.1f772345.png";